// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2m9VX","colCheckbox":"styles_colCheckbox__2qZny"};